// src/pages/admin/{Notice1FormForm.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import Notice1Form from "../../forms/anounce/Notice-of-Dissolution-1st-Publication/NoticeofDissolution1stPublication";

function Notice1Page() {
  return (
    <FormWrapper
      title="เลิกบริษัทประกาศเลิกขั้นตอนที่1"
      FormComponent={Notice1Form}
      formKey="notice-dissolution-1st" // key ไว้แยกชื่อไฟล์รูป/เก็บ localStorage ถ้ามี
    />
  );
}

export default Notice1Page;
